export const complianceService = {
  async getComplianceStatus() {
    try {
      // Return comprehensive mock compliance status data
      return {
        success: true,
        data: {
          overallComplianceScore: 94.7,
          complianceStatus: 'Compliant',
          lastAuditDate: new Date(Date.now() - 2592000000).toISOString(), // 30 days ago
          nextAuditDate: new Date(Date.now() + 7776000000).toISOString(), // 90 days from now
          certificationStatus: 'Active',
          regulatoryFrameworks: [
            {
              framework: 'SOX (Sarbanes-Oxley)',
              status: 'Compliant',
              score: 96.2,
              lastReview: new Date(Date.now() - 1296000000).toISOString(), // 15 days ago
              nextReview: new Date(Date.now() + 7776000000).toISOString(), // 90 days from now
              requirements: [
                { requirement: 'Financial Reporting Controls', status: 'Compliant', score: 98.1 },
                { requirement: 'Internal Control Assessment', status: 'Compliant', score: 95.7 },
                { requirement: 'Management Certification', status: 'Compliant', score: 94.3 }
              ]
            },
            {
              framework: 'GDPR (General Data Protection Regulation)',
              status: 'Compliant',
              score: 93.8,
              lastReview: new Date(Date.now() - 864000000).toISOString(), // 10 days ago
              nextReview: new Date(Date.now() + 5184000000).toISOString(), // 60 days from now
              requirements: [
                { requirement: 'Data Processing Consent', status: 'Compliant', score: 95.2 },
                { requirement: 'Right to be Forgotten', status: 'Compliant', score: 92.1 },
                { requirement: 'Data Breach Notification', status: 'Compliant', score: 94.1 }
              ]
            },
            {
              framework: 'SEC Investment Adviser Regulations',
              status: 'Compliant',
              score: 95.1,
              lastReview: new Date(Date.now() - 1728000000).toISOString(), // 20 days ago
              nextReview: new Date(Date.now() + 6480000000).toISOString(), // 75 days from now
              requirements: [
                { requirement: 'Form ADV Filing', status: 'Compliant', score: 97.3 },
                { requirement: 'Custody Rule Compliance', status: 'Compliant', score: 93.8 },
                { requirement: 'Marketing Rule Compliance', status: 'Compliant', score: 94.2 }
              ]
            },
            {
              framework: 'FINRA (Financial Industry Regulatory Authority)',
              status: 'Compliant',
              score: 92.6,
              lastReview: new Date(Date.now() - 2160000000).toISOString(), // 25 days ago
              nextReview: new Date(Date.now() + 5184000000).toISOString(), // 60 days from now
              requirements: [
                { requirement: 'Know Your Customer (KYC)', status: 'Compliant', score: 94.7 },
                { requirement: 'Anti-Money Laundering (AML)', status: 'Compliant', score: 91.2 },
                { requirement: 'Suitability Requirements', status: 'Compliant', score: 91.9 }
              ]
            }
          ],
          riskAssessment: {
            overallRisk: 'Low',
            riskScore: 15.3, // Lower is better
            riskFactors: [
              {
                factor: 'Regulatory Changes',
                riskLevel: 'Medium',
                impact: 'Moderate',
                mitigation: 'Continuous monitoring and legal counsel'
              },
              {
                factor: 'Data Privacy Violations',
                riskLevel: 'Low',
                impact: 'High',
                mitigation: 'Robust data protection measures and staff training'
              },
              {
                factor: 'Financial Reporting Errors',
                riskLevel: 'Very Low',
                impact: 'High',
                mitigation: 'Automated controls and regular audits'
              }
            ]
          },
          auditTrail: [
            {
              date: new Date(Date.now() - 432000000).toISOString(), // 5 days ago
              auditor: 'Internal Compliance Team',
              scope: 'Data Privacy Controls',
              result: 'No Issues Found',
              recommendations: 0
            },
            {
              date: new Date(Date.now() - 1296000000).toISOString(), // 15 days ago
              auditor: 'External Auditor - PwC',
              scope: 'SOX Compliance Review',
              result: 'Minor Recommendations',
              recommendations: 2
            },
            {
              date: new Date(Date.now() - 2592000000).toISOString(), // 30 days ago
              auditor: 'Regulatory Consultant',
              scope: 'SEC Investment Adviser Compliance',
              result: 'Fully Compliant',
              recommendations: 0
            }
          ],
          pendingActions: [
            {
              action: 'Update Privacy Policy for New Regulations',
              priority: 'Medium',
              dueDate: new Date(Date.now() + 1209600000).toISOString(), // 14 days from now
              assignee: 'Legal Department',
              status: 'In Progress'
            },
            {
              action: 'Quarterly SOX Testing',
              priority: 'High',
              dueDate: new Date(Date.now() + 604800000).toISOString(), // 7 days from now
              assignee: 'Internal Audit',
              status: 'Scheduled'
            }
          ],
          certifications: [
            {
              certification: 'ISO 27001 Information Security',
              status: 'Active',
              issueDate: new Date(Date.now() - 31536000000).toISOString(), // 1 year ago
              expiryDate: new Date(Date.now() + 63072000000).toISOString(), // 2 years from now
              certifyingBody: 'BSI Group'
            },
            {
              certification: 'SOC 2 Type II',
              status: 'Active',
              issueDate: new Date(Date.now() - 15552000000).toISOString(), // 6 months ago
              expiryDate: new Date(Date.now() + 15552000000).toISOString(), // 6 months from now
              certifyingBody: 'Deloitte'
            }
          ],
          complianceMetrics: {
            policyAcknowledgmentRate: 98.7,
            trainingCompletionRate: 96.3,
            incidentResponseTime: '2.3 hours',
            auditFindingsResolutionRate: 100,
            regulatoryFilingTimeliness: 99.2
          },
          recentAlerts: [
            {
              type: 'info',
              message: 'New SEC marketing rule guidance published',
              date: new Date(Date.now() - 172800000).toISOString(), // 2 days ago
              severity: 'Low',
              actionRequired: 'Review and assess impact'
            },
            {
              type: 'warning',
              message: 'Upcoming GDPR compliance training deadline',
              date: new Date(Date.now() - 86400000).toISOString(), // 1 day ago
              severity: 'Medium',
              actionRequired: 'Ensure all staff complete training'
            }
          ],
          complianceTraining: {
            overallCompletionRate: 96.3,
            upcomingDeadlines: [
              {
                course: 'Annual Anti-Money Laundering Training',
                deadline: new Date(Date.now() + 1209600000).toISOString(), // 14 days from now
                completionRate: 78.4
              },
              {
                course: 'Data Privacy and GDPR Update',
                deadline: new Date(Date.now() + 604800000).toISOString(), // 7 days from now
                completionRate: 89.2
              }
            ]
          }
        }
      }
    } catch (error) {
      console.error('Compliance service error:', error)
      return {
        success: false,
        data: null,
        error: 'Failed to fetch compliance status'
      }
    }
  }
}
